import PropTypes from "prop-types";
import React from "react";

import Icon from "layout/atoms/Icon";

import { ReactComponent as BoardsSvg } from "assets/illustrations/empty-state-boards.svg";
import { ReactComponent as IdeasSvg } from "assets/illustrations/empty-state-ideas.svg";
import {
  ReactComponent as NoResultsSvg,
  ReactComponent as NotFoundSvg,
} from "assets/illustrations/empty-state-not-found.svg";
import { ReactComponent as ReleasesSvg } from "assets/illustrations/empty-state-releases.svg";
import { ReactComponent as UsersSvg } from "assets/illustrations/empty-state-users.svg";
import { Text, Wrapper } from "./styles";

const EmptyState = ({ type, header, subheader, button, children }) => {
  const icons = {
    noBoards: BoardsSvg,
    noIdeas: IdeasSvg,
    noReleases: ReleasesSvg,
    noUsers: UsersSvg,
    notFound: NotFoundSvg,
    noResults: NoResultsSvg,
  };

  return (
    <Wrapper>
      <Icon src={icons[type]} size="200px" />
      <Text>
        <h3>{header}</h3>
        <h4>{subheader}</h4>
      </Text>
      {children}
    </Wrapper>
  );
};

EmptyState.propTypes = {
  type: PropTypes.oneOf([
    "noBoards",
    "noIdeas",
    "noReleases",
    "noUsers",
    "notFound",
    "noResults",
  ]),
  header: PropTypes.string,
  subheader: PropTypes.string,
  button: PropTypes.string,
};

export default EmptyState;
